import React, { Suspense, createContext, lazy } from 'react'
import Provider from './Provider'

// const Provider = typeof window === 'undefined' ? () => null : lazy(() => import('./Provider'))

function Physics(props) {
  return (
    // <Suspense fallback={null}>
      <Provider {...props} />
    // </Suspense>
  )
}

export { Physics }
